import { useQuery } from 'react-query'

import { HttpError } from '@webapp/infrastructure/interfaces/services/IHttpClient'
// eslint-disable-next-line import/no-internal-modules
import { SystemPreferencesRepository } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository'
// eslint-disable-next-line import/no-internal-modules
import { systemPreferencesKeys } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository/queryKey.factory'
// eslint-disable-next-line import/no-internal-modules
import { SystemPreferenceKeys } from '@webapp/platform/iam/entities/enums/SystemPreferenceKeys'

// The kvstore signals "preference never set" either as a 404 or by omitting
// the key from the GET-all response (which the repository surfaces as an
// "Invalid system preference key" error). Anything else is a real failure and
// must propagate — never cache it as a successful "off" (BHV-004).
const isUnsetPreferenceError = (error: unknown): boolean => {
  if (error instanceof HttpError) {
    return error.status === 404
  }

  return (
    error instanceof Error &&
    error.message ===
      `Invalid system preference key: ${SystemPreferenceKeys.AUTO_PO_CUSTOM_SEQUENCE}`
  )
}

export const useQueryExternalPONumberingSetting = () => {
  const { data, isLoading } = useQuery({
    queryKey: systemPreferencesKeys.externalPONumbering,
    queryFn: async (): Promise<boolean> => {
      try {
        const preference =
          await SystemPreferencesRepository.getSystemPreference(
            SystemPreferenceKeys.AUTO_PO_CUSTOM_SEQUENCE
          )
        return preference.value
      } catch (error) {
        if (isUnsetPreferenceError(error)) {
          // 404 / missing key is a valid "off" state — never surfaced as an
          // error (BHV-004)
          return false
        }
        throw error
      }
    },
  })

  return {
    value: data ?? false,
    isLoading,
  }
}
